/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum SampleStatus {
  NotTested = 'This test has not yet been done',

  ReferredOut = 'test has been referred to an outside lab and the results have not been returned',

  ReferredIn = 'test has been done at an outside lab and then referred to this lab',

  Finalized = 'The results of the analysis are final',

  BiologistRejection = 'The Biologist did not accept this result as valid',

  TestCanceled = 'Test was requested but then canceled',

  TechnicalAcceptance = 'The results of the test were accepted by technician as being valid',

  TechnicalRejected = 'The results of the test were not accepted by the technicain',

  TestEntered = 'No tests have been run for this order',

  TestingStarted = 'Some tests have been run on this order',

  TestingFinished = 'All tests have been run on this order',

  SampleCanceled = 'The sample has been canceled by the user',

  SampleEntered = 'The sample has been entered into the system',

  NonConforming = 'The order is non-conforming',

  TechnicalAcceptanceRO = 'The order is TechnicalAcceptance',

  FinalizedRO = 'The order is Finalized',

  BiologistRejectionRO = 'The order is BiologistRejection',
}
